import { render, staticRenderFns } from "./applicant-recurrent-commission.vue?vue&type=template&id=b3be9d70&"
import script from "./applicant-recurrent-commission.vue?vue&type=script&lang=js&"
export * from "./applicant-recurrent-commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports